import {defaults, assign} from 'lodash';
import {clamp, round} from '@packages/systems/core/utils/NumberUtils';

export const KNOB_DIAMETER = 10;

const roundWithStep = (value, step) => {
  if (step === 0) {
    return value;
  }
  // In case step is a floating point number we need to round the final result as well.
  return round(Math.round(value / step) * step);
};

export const mapValue = (displacement, length, min, max) => {
  const value = (displacement / length) * (max - min) + min;
  return clamp(min, max, value);
};

export const computeValue = (
  {length, min, max, step, knobSize},
  displacement
) => {
  const adjustedDisplacement = displacement - knobSize / 2;
  const adjustedLength = length - knobSize;
  return roundWithStep(
    mapValue(adjustedDisplacement, adjustedLength, min, max),
    step
  );
};

export const getKnobPosition = ({
  min,
  max,
  value,
  length,
  reverse,
  knobSize,
}) => {
  const clampedValue = clamp(min, max, value);
  const position = Math.round(
    ((clampedValue - min) / (max - min)) * (length - knobSize)
  );
  return reverse ? length - position : position;
};

export const getInitialState = (props) => {
  return assign(
    {
      min: 0,
      max: 100,
      value: 50,
      step: 1,
      knobSize: 0,
      length: 100,
      vertical: false,
      reverse: false,
      dragging: false,
    },
    props
  );
};

export const dragStart = (state, coordinates) => {
  const displacement = coordinates[state.vertical ? 'y' : 'x'];
  const adjustedDisplacement = state.reverse
    ? state.length - displacement
    : displacement;

  return defaults(
    {
      dragging: true,
      value: computeValue(state, adjustedDisplacement),
    },
    state
  );
};

export const drag = (state, coordinates) => {
  const displacement = coordinates[state.vertical ? 'y' : 'x'];
  const adjustedDisplacement = state.reverse
    ? state.length - displacement
    : displacement;

  return defaults(
    {
      value: computeValue(state, adjustedDisplacement),
    },
    state
  );
};

export const dragEnd = (state) => {
  return defaults(
    {
      dragging: false,
    },
    state
  );
};
